import { render, staticRenderFns } from "./BalanceRecharge.vue?vue&type=template&id=3bb05506&scoped=true"
import script from "./BalanceRecharge.vue?vue&type=script&lang=js"
export * from "./BalanceRecharge.vue?vue&type=script&lang=js"
import style0 from "./BalanceRecharge.vue?vue&type=style&index=0&id=3bb05506&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb05506",
  null
  
)

export default component.exports